var timer = null

var obj = {
    init: function () {
        this.aniType();        // 动画类型        
        this.bind();				   // 所有绑定事件
        this.swiper();         // 轮播图
    },
    // 动画类型
    aniType: function() {
      var location = window.location.href;
      var type = location.split('?type=')[1];
      if(type == 2) {
        // 初始人物消失的动画
        obj.initPage();

        // 默认执行第一页
        obj.openPage(1, 500);

        $('.preloading').hide();
      } else {
        this.preloading();     // 图片资源预加载
      }
    },
    // 图片资源预加载
    preloading: function () {
        //图片预加载
        var queue = new createjs.LoadQueue();
        queue.on("progress", function (e) {
            //加载中的进度
            if (e.progress * 100 >= 10) {
                $(".loding_time span").width(parseInt(e.progress * 100) + '%')
            }
            ;
            var numbers = e.progress * 100;
        }, this);
        queue.on("complete", function (e) {
            //加载完成执行操作
            $('.landing').css({'opacity': '1'});
            $('.page-1').addClass('page-scale-1');
            $('.preloading').fadeOut();
        }, this);
        queue.loadManifest([
            //加载图片，不包括后台的
            '//static.qcplay.com/snail/yssjg/images/pc/page_bg_1.png',
            '//static.qcplay.com/snail/yssjg/images/pc/page_bg_2.png',
            '//static.qcplay.com/snail/yssjg/images/pc/page_bg_3.png',
        ]);
    },
    // 弹窗文本滚动
    jqslideTxtBox: function(id) {
        var area = document.getElementById("i" + id + "");
        area.scrollTop = 0; 
        
        var con2 = $("#i"+ id + " .infoList2");
        var ul = document.getElementById("t" + id + "")
        let height = ul.offsetHeight;
        //封装函数 用来判断滚动条的距离与盒子高度的关系
        function scrollUp(){
          if(area.scrollTop>=height){

              area.scrollTop=0;

          }else{

              area.scrollTop++;

          }
          
        }
        //解决暴力用户 在开启定时器之前最好先清除一下定时器
        clearInterval(timer);
        //开始定时器
        timer = setInterval(scrollUp,40);
        
        //为对象设置绑定鼠标滑过
        area.onmouseover = function() {
          clearInterval(timer);
        }
        //为对象绑定鼠标划出
        area.onmouseout = function() {
            timer=setInterval(scrollUp,40);
        }
    },
    // 所有绑定事件
    bind: function () {
      // 蝴蝶页面默认初始动画
      var scene = document.getElementById('scene');
      var parallax = new Parallax(scene);

      var Media = document.getElementById('media-play');
      
      //适龄弹窗
      $(".year_box").click(function() {
        $(".year_pop").fadeIn();
      });

      $(".close-btn").click(function() {
        $('.popup_wrap').fadeOut();
        $(".monster div").css("display","none")
        $(".text_wrap").css("display","none")
        $(".text_pop .close-btn").fadeOut();
        clearInterval(timer);
      })

      $(".close-bg").on('click', function() {
        $('.popup_wrap').fadeOut();
      })

      // 弹窗打开
      $(".float").on('click', function() {
        let id = $(this).attr("data-id");
        $(".text_pop").fadeIn();
     
        setTimeout(()=> {
          // 怪兽展示
          $(".m" + id +"").fadeIn();
          $(".window").fadeIn();
          // 对应文案打开
          $("#i" + id +"").fadeIn();
          // 文本滚动开启
          obj.jqslideTxtBox(id);

          $(".text_pop .close-btn").fadeIn();
        }, 1000)
        
      })

      // 点击进入下一页
      $('.page').on('click', '.open-btn', function(event) {            
        var _data = $(this).attr('data');
        var _time = $(this).attr('time');
        // 每一页的效果
        obj.openPage(_data, _time);
        // 初始人物消失的动画
        obj.initPage();
      });

    
      $(".hint_pop").on('click', function()  {
        $(".hint_pop").fadeOut();
      })

      // 点击开启视频-弹窗
      $('.s-video-btn').click(function(event) {
          $('.video-wrap').fadeIn();
          $('.s-video-btn').fadeOut();
          Media.play();
          musicOff();
      });

      // 关闭视频-弹窗
      $('.video-close-bg').click(function(event) {
          $('.video-wrap').fadeOut();
          $('.s-video-btn').fadeIn();
          $('.page-5 .new-next-step-btn').fadeIn();
          Media.pause();
      });

      // 音频关闭
      $('.play-btn').click(function(){
          musicOff();
      });

      // 音乐按钮
      $('.music').click(function(event) {
          var _this = $(this);
          if ($('#myMusic')[0].paused) {
              $('#myMusic')[0].play();
              _this.addClass('on');
          } else {
              $('#myMusic')[0].pause();
              _this.removeClass('on')
          }
      });

      // 音频关闭
      function musicOff() {
          $('.play-btn').fadeOut();
          Media.play();
          $('#myMusic')[0].pause();
          $('.music').removeClass('on')
      }
    },

    // 初始人物消失动画
    initPage: function() {
      // 目前播放到第五页停止
      $('.man-1, .man-2').addClass('man_ani');  // 人物动画开启
      $('.year, .logo, .entry_btn').hide();  // 按钮 logo 适龄消失
      $('.circle_1, .circle_2, .circle_3, .circle_bg,').addClass("quick");  // 圆圈转速变快
      setTimeout(()=> {
        $(".entry").addClass("fade");
      }, 500)
    },

    // 翻页动画
    openPage: function(pageId, isTime) {
      setTimeout(() => {
          var pageNum = Number(pageId) + 1;
          $('.page-'+ pageId +'').addClass('page-disappear');
          setTimeout(() => {
              $('.page-'+ pageNum +'').fadeIn()
              setTimeout(() => {
                  $('.page-'+ pageNum +'').addClass('page-scale-'+ pageNum +''); 
                  setTimeout(()=> {
                    if(pageId == 1) {
                      $('.page-'+ pageNum +' .main').addClass('active'); 
                      this.nextPage()
                    }
                  }, isTime)
              }, 0);
          }, 50);
      }, isTime);
    },

    // 第二页到第三页
    nextPage: function() {
      setTimeout(()=> {
        obj.openPage("2", 1000)
        setTimeout(()=> {
          $('.year, .logo, .official-btn, .return-btn').fadeIn();
          setTimeout(()=> {
            // 提示层打开
          $(".hint_pop").fadeIn();
          }, 1000)
        }, 1000)
        $(".index .page-3 .swiper-container .main .light .line").addClass("line_active");
      }, 1000)
    },

    // 第三屏轮播
    swiper: function() {

      var mySwiper = new Swiper('.swiper-container', {
          // pagination: '.swiper-pagination',
          direction: 'horizontal',
          slidesPerView: 'auto',
          speed: 1500,
          touchRatio: .7,
          mousewheelControl: true,
          resistanceRatio: 0,  // 边缘不拖拽
          freeMode: true,
          freeModeMomentum : false,
          freeModeMomentumRatio: 2,
          freeModeMomentumBounce: false,
          noSwiping : true,
          loop: false,
          mousewheelSensitivity: .8,
          onInit: function(swiper) {
              swiperAnimate(swiper);

          },
          onSlideChangeStart: function(swiper) {
              // // 首屏切换
              console.log(swiper.realIndex)
          },
          onSlideChangeEnd: function(swiper) {
              swiperAnimate(swiper);
          },
      });
  },
}